<template>
  <div v-show="value" class="non-dom-remove-dialog">
    <div class="non-dom-remove-dialog__backdrop" @click="close" />
    <div class="non-dom-remove-dialog__content">
      <q-btn
        icon="close"
        class="non-dom-remove-dialog__close"
        round
        @click="close"
      />
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Диалог остающийся в дом и скрываюшийся только за счет стилей
 * @module Shared/Component/KeepDomDialog
 * @fires module:Shared/Component/KeepDomDialog#close
 * @vue-event {void} close - Закрытие диалога
 * */

export default {
  props: {
    value: Boolean
  },
  methods: {
    /**
     * Закрытие диалога
     * @fires module:Shared/Component/KeepDomDialog#close
     * */
    close() {
      /**
       * Закрытие диалога
       * @event module:Shared/Component/KeepDomDialog#close
       * @type {void}
       * */
      this.$emit('close')
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss">
.non-dom-remove-dialog {
  padding: var(--container-y-padding) var(--container-x-padding);
}

.non-dom-remove-dialog,
.non-dom-remove-dialog__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.non-dom-remove-dialog__backdrop {
  background-color: rgba(0,0,0,0.4);
}

.non-dom-remove-dialog__content {
  padding: 1px;
  position: relative;
}

.non-dom-remove-dialog__close {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
